(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["More-Product"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
     $('.product-section').flickity({
  	contain: true,
  	pageDots: false,
  	cellAlign: 'center',
  	"wrapAround": true
  });
});
   


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
    $(".account__menu > li").click(function() {
    //    console.log($(this).data('goto'));
    //    console.log($("#"+$(this).data('goto')));
       $(".account__menu > li").removeClass('active');
       $(this).addClass('active');
       
       $('html, body').stop().animate({
            'scrollTop': $("#"+$(this).data('goto')).offset().top - 70
            },
            600,
            'swing'
        );
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-menopause"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
    $('.product-section').flickity({
  	pageDots: false,
  	contain: true,
 	  "wrapAround": true,
    cellAlign: 'center',
      "adaptiveHeight": true,
      draggable: false
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
$( document ).ready(function() {
  $custom_review_desk = $('#custom_review_desk');
  $custom_review_mob = $('#custom_review_mob');

  if($custom_review_desk.length){
    $custom_review_desk.flickity({
  	"adaptiveHeight": true,
  	"pageDots": false
    });
  }
  
  if($custom_review_mob.length){
    $custom_review_mob.flickity({
  	"adaptiveHeight": true,
  	"pageDots": false
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
